import React from 'react'
import { cn } from '@/lib/utils'

interface NavbarProps extends React.HTMLAttributes<HTMLElement> {
  color?: string
  light?: boolean
  dark?: boolean
  expand?: boolean | string
  fixed?: string
  sticky?: string
  tag?: React.ElementType
}

export const Navbar: React.FC<NavbarProps> = ({
  color,
  light,
  dark,
  expand,
  fixed,
  sticky,
  className,
  children,
  tag: Tag = 'nav',
  ...props
}) => (
  <Tag
    className={cn(
      'navbar',
      color && `navbar-${color === 'white' ? 'light' : color}`,
      light && 'navbar-light',
      dark && 'navbar-dark',
      expand === true
        ? 'navbar-expand'
        : typeof expand === 'string'
          ? `navbar-expand-${expand}`
          : undefined,
      fixed && `fixed-${fixed}`,
      sticky && `sticky-${sticky}`,
      color && `bg-${color}`,
      className,
    )}
    {...props}
  >
    {children}
  </Tag>
)
